// extracted by mini-css-extract-plugin
export var ctaBody = "whatsNewTimeline-module--ctaBody--e0af5";
export var ctaHeadline = "whatsNewTimeline-module--ctaHeadline--93949";
export var filterAccordion = "whatsNewTimeline-module--filterAccordion--b91a0";
export var whatsNewTimeline = "whatsNewTimeline-module--whatsNewTimeline--97349";